import { useEffect, useRef } from 'react';
import Select from 'react-select';
import { isMobile } from './../helpers';

export default function CustomSelect(props: any) {
  const customStyles = {
    menu: (provided: any, state: any) => ({
      ...provided,
      outlineStyle: 'solid',
      outlineColor: 'white',
      outlineWidth: '2px',
      borderRadius: '15px',
      boxShadow: '0px 8px 8px 4px rgba(0,0,0,0.1)',
      top: isMobile() ? '50px' : null,
    }),
    option: (provided: any, state: any) => ({
      ...provided,
      backgroundColor:
        state.isSelected ? '#faf6ef' : 'white',
      fontWeight: state.isSelected ? 'bold' : 'normal',
      cursor: state.isFocused ? 'pointer' : 'hand',
      fontSize: '15px',
      borderBottomStyle: 'solid',
      borderBottomWidth: '1px',
      borderBottomColor: '#e3e3e3',
      marginTop: '3px',
      paddingBottom: props.smallOptionHeight ? '8px' : '12px',
      paddingTop: props.smallOptionHeight ? '8px' : '12px',
      color: '#3c3c3c',
      width: '90%',
      margin: 'auto',
      paddingLeft: '10px',
    }),
    control: (provided: any, state: any) => ({
      ...provided,
      borderRadius: '60px',
      height: isMobile() ? '48px' : '100%',
      borderColor: props.noBorder
        ? 'white'
        : state.isFocused ||
          state.isSelected ||
          state.isHovered ||
          state.isActive
        ? 'black'
        : '#3c3c3c',
      fontSize: '16px',
      paddingLeft: '10px',
      paddingRight: '14px',
    }),
    singleValue: (provided: any, state: any) => ({
      ...provided,
      fontSize: isMobile() ? '14px' : '15px',
      marginTop: '3px',
    }),
    container: (provided: any, state: any) => ({
      ...provided,
      height: '100%',
    }),
    indicatorSeparator: (provided: any, state: any) => ({
      ...provided,
      display: 'none',
    }),
    dropdownIndicator: (provided: any, state: any) => ({
      ...provided,
      color: '#3C3C3C !important',
    }),
  };

  const selectRef: any = useRef(null);

  useEffect(() => {
    if (selectRef.current) {
      const selectElements = [];
      selectElements.push({
        element: document.querySelectorAll('.react-select > div')[0],
        addToId: '',
      });
      selectElements.push({
        element: document.querySelectorAll(
          ".react-select div[class$='placeholder']"
        )[0],
        addToId: '-placeholder',
      });
      selectElements.push({
        element: document.querySelectorAll(
          ".react-select div[class$='singleValue']"
        )[0],
        addToId: '-singleValue',
      });
      selectElements.push({
        element: document.querySelectorAll(
          ".react-select div[class$='indicatorContainer']"
        )[0],
        addToId: '',
      });
      selectElements.forEach((selectElement) => {
        if (selectElement.element) {
          selectElement.element.setAttribute('data-zuko-tag-name', 'SELECT');
          selectElement.element.setAttribute(
            'data-zuko-id',
            props.zukoId + selectElement.addToId
          );
        }
      });
    }
  }, [selectRef]);

  return (
    <Select
      {...props}
      styles={customStyles}
      blurInputOnSelect={true}
      isSearchable={false}
      className="react-select"
      ref={selectRef}
      onMenuOpen={props.onMenuOpen}
      onMenuClose={props.onMenuClose}
    />
  );
}
